import React from "react";
import { Link } from "react-router-dom";
import Logo from './assets/logo.jpg';

export default class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = { mobileToggle: 'mobile-menu', subscribeToggle: 'subscribe-container-hidden' };
        this.mobileMenuOpen = this.mobileMenuOpen.bind(this);
        this.mobileMenuClose = this.mobileMenuClose.bind(this);
        this.susbcribeOpen = this.susbcribeOpen.bind(this);
        this.subscribeClose = this.subscribeClose.bind(this);
        this.closeAllWrapper = this.closeAllWrapper.bind(this);
    }

    mobileMenuOpen() {
        this.setState({ mobileToggle: 'mobile-menu-open' })
    }

    mobileMenuClose() {
        this.setState({ mobileToggle: 'mobile-menu-hidden' })
    }

    susbcribeOpen() {
        this.setState({ subscribeToggle: 'subscribe-container' })
    }

    subscribeClose() {
        this.setState({ subscribeToggle: 'subscribe-container-hidden-triggered' })
    }

    closeAllWrapper(){
        this.mobileMenuClose();
        this.subscribeClose();
    }

    render(){
        return(
            <div className="navbar-container">
                <div className="navbar">
                    <Link to='/'><div className="navbar-logo"><img className="site-logo" src={Logo} /></div></Link>
                    <div className="navbar-links">
                        <ul>
                            <li><Link to='/'>Home</Link></li>
                            <li><Link to='/blog'>Blog</Link></li>
                            <li><Link to='/contact'>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="navbar-cta-container">
                        <button onClick={this.susbcribeOpen} className="navbar-cta">Subscribe</button>
                    </div>
                    <div onClick={ this.mobileMenuOpen } className="mobile-menu-toggle">
                        <i class="fa fa-bars" aria-hidden="true"></i>
                    </div>
                    <div className={ this.state.mobileToggle }>
                        <i onClick={ this.mobileMenuClose } class="fa fa-times-circle-o" aria-hidden="true"></i>
                        <ul>
                            <li onClick={ this.mobileMenuClose }><Link to='/'>Home</Link></li>
                            <li onClick={ this.mobileMenuClose }><Link to='/blog'>Blog</Link></li>
                            <li onClick={ this.mobileMenuClose }><Link to='/contact'>Contact</Link></li> 
                        </ul>
                        <button onClick={this.susbcribeOpen} className="navbar-cta">Subscribe</button>
                    </div>
                </div>

                <div className={ this.state.subscribeToggle }>
                    <div className="susbcribe-grey"></div>
                    <div className="subscribe-body-container">
                        <div className="subscribe-body">
                            <div className="subscribe-body-header">
                                <h2>Subscribe now</h2>
                                <div onClick={this.subscribeClose}>
                                    <i class="fa fa-times-circle-o" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div className="subscribe-body-body">
                                <form name="subscribe" method="post" className="subscribe-form">
                                    <input type="hidden" name="form-name" value="subscribe" />
                                    <div>
                                        <p>Give us a call or fill in the form below and we will contact you.
                                        We endeavor to answer all inquiries within 24 hours on business days.</p>
                                        <input name="email" type="text" placeholder="&nbsp; Enter your email" />
                                        <button type="submit">Subscribe</button>
                                    </div>
                                    <div>
                                        <input name="contact permission" type="checkbox" />
                                        <p>I agree to receive newletters and other offers.</p>
                                    </div>
                                </form>
                            </div>

                            <div className="side-bar-social">
                                <div>
                                    <div className="icon-div">
                                        <i class="fa fa-facebook" aria-hidden="true"></i>
                                    </div>
                                    <div className="icon-div">
                                        <i class="fa fa-twitter" aria-hidden="true"></i>
                                    </div>
                                    <div className="icon-div">
                                        <i class="fa fa-instagram" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}